import React from "react";

const Header = () => {
  return (
    <div className="header">
      <span>Advanced Influencer Management System (IMS)</span>
    </div>
  );
};

export default Header;
